import { VALUE_UPDATE_EVENT } from "../../lib/constants.js";
import { computed, createBlock, createCommentVNode, createVNode, openBlock, renderSlot, unref, withCtx, withModifiers } from "vue";
import { DtButton, DtInput, DtText } from "@dialpad/dialtone-vue";
import { DtIconClose } from "@dialpad/dialtone-icons/vue";
//#region src/components/controls/control_slot.vue
var _sfc_main = /* @__PURE__ */ Object.assign({ name: "DtcControlSlot" }, {
	props: {
		value: {
			type: void 0,
			default: () => null
		},
		disabled: {
			type: Boolean,
			default: false
		},
		defaultValue: {
			type: void 0,
			default: () => null
		}
	},
	emits: [VALUE_UPDATE_EVENT],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const isModified = computed(() => props.value !== props.defaultValue);
		function updateValue(e) {
			emit(VALUE_UPDATE_EVENT, e || null);
		}
		function onReset() {
			emit(VALUE_UPDATE_EVENT, props.defaultValue);
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(DtInput), {
				"model-value": __props.value,
				disabled: __props.disabled,
				type: "textarea",
				"input-class": "d-pie-400",
				spellcheck: "false",
				size: 100,
				onInput: updateValue
			}, {
				label: withCtx(() => [createVNode(unref(DtText), {
					kind: "label",
					size: 100,
					tone: "secondary",
					class: "d-input__label-text"
				}, {
					default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
					_: 3
				})]),
				endIcon: withCtx(() => [isModified.value ? (openBlock(), createBlock(unref(DtButton), {
					key: 0,
					kind: "muted",
					importance: "clear",
					size: 100,
					class: "d-p-25 d-mie-n200",
					onClick: withModifiers(onReset, ["stop"])
				}, {
					icon: withCtx(() => [createVNode(unref(DtIconClose), { size: "100" })]),
					_: 1
				})) : createCommentVNode("", true)]),
				_: 3
			}, 8, ["model-value", "disabled"]);
		};
	}
});
//#endregion
export { _sfc_main as default };

//# sourceMappingURL=control_slot.vue.js.map